import { apiRequest } from "@/common/api/ApiRequest.ts";
import type { MenuTypes } from "@/common/types/MenuTypes.ts";
import { ApiMethod } from "@/common/types/Enums.ts";


/**
 * Base API path
 * Format: /api/(admin/corp/person)/~
 * Used to organize routes by user role
 */
const _url = "/api/v1/client/menu";

/**
 * summary: Get Menu List ( 메뉴 목록 조회 )
 * #GET./api/v1/admin/menu
 */
export const getMenuList = async (id: string): Promise<MenuTypes> => {
  return await apiRequest<MenuTypes>({
    url: _url + "/list",
    method: ApiMethod.GET,
  });
};

/**
 * summary: Get Quick Menu List ( 퀵메뉴 목록 조회 )
 * #GET./api/v1/admin/menu/quick-menu
 */

export const getQuickMenuList = async (): Promise<MenuTypes[]> => {
  return await apiRequest<MenuTypes[]>({
    url: _url + "/quick-list",
    method: ApiMethod.GET,
  }); 

};